import gtm from '@periodica/analytics/gtm';
import wrapWithProvider from './wrap-with-provider';

import './src/styles/index.scss';

export const wrapRootElement = wrapWithProvider;

const siteBranchName = process.env.BRANCH;

const sendCurrentBranchEvent = () => {
  gtm.logEvent({
    name: 'event_track_branch',
    data: {
      branch: `site_${siteBranchName}`,
    },
  });
};

const scroll = () => {
  document.body.scrollTop = 0;
};

const initScripts = () => {
  sendCurrentBranchEvent();
};

export const shouldUpdateScroll = scroll;
export const onClientEntry = initScripts;
